import type {
	NotificationSettings,
	NotificationSettingsUpdate,
	PushSubscriptionInput
} from '@andresot/protocol';
import { request } from './client.js';

export async function fetchNotificationSettings(): Promise<NotificationSettings> {
	const response = await request<{ settings: NotificationSettings }>('/api/notifications/settings');
	return response.settings;
}

export async function updateNotificationSettings(
	input: NotificationSettingsUpdate
): Promise<NotificationSettings> {
	const response = await request<{ settings: NotificationSettings }>(
		'/api/notifications/settings',
		{
			method: 'PATCH',
			body: input
		}
	);
	return response.settings;
}

export async function fetchVapidKey(): Promise<{ enabled: boolean; publicKey: string | null }> {
	return request('/api/notifications/vapid-key');
}

export async function savePushSubscription(subscription: PushSubscriptionInput): Promise<void> {
	await request('/api/notifications/subscriptions', { body: subscription });
}

export async function deletePushSubscription(endpoint: string): Promise<void> {
	await request('/api/notifications/subscriptions', {
		method: 'DELETE',
		body: { endpoint }
	});
}
